import apiService from './apiService';

// الحصول على جميع الحسابات
export const getAllAccounts = async (params: any = {}): Promise<any[]> => {
  try {
    const response = await apiService.get<any[]>('/finance/accounts', { params });
    return response || [];
  } catch (error) {
    console.error('Error fetching all accounts:', error);
    throw error;
  }
};

// الحصول على تفاصيل حساب معين
export const getAccountById = async (id: string): Promise<any> => {
  try {
    const response = await apiService.get(`/finance/accounts/${id}`);
    return response;
  } catch (error) {
    console.error(`Error fetching account with id ${id}:`, error);
    throw error;
  }
};

// تحديث حساب موجود
export const updateAccount = async (id: string, data: any): Promise<any> => {
  try {
    const response = await apiService.put(`/finance/accounts/${id}`, data);
    return response;
  } catch (error) {
    console.error(`Error updating account with id ${id}:`, error);
    throw error;
  }
};

// تحديث حالة الحساب (نشط/غير نشط)
export const updateAccountStatus = async (id: string, isActive: boolean): Promise<any> => {
  try {
    console.log(`تغيير حالة الحساب ${id} إلى ${isActive ? 'نشط' : 'غير نشط'}`);
    const response = await apiService.put(`/finance/accounts/${id}`, { isActive });
    return response;
  } catch (error) {
    console.error(`Error updating account status with id ${id}:`, error);
    throw error;
  }
};

// الحصول على قائمة الحسابات النشطة
export const getActiveAccounts = async (): Promise<any[]> => {
  try {
    const response = await apiService.get<any[]>('/finance/accounts/selection/active');
    return response || [];
  } catch (error) {
    console.error('Error fetching active accounts:', error);
    throw error;
  }
};

// الحصول على قائمة الحسابات غير النشطة
export const getInactiveAccounts = async (): Promise<any[]> => {
  try {
    const response = await apiService.get<any[]>('/finance/accounts/selection/inactive');
    return response || [];
  } catch (error) {
    console.error('Error fetching inactive accounts:', error);
    throw error;
  }
};

// تصدير الحسابات إلى CSV
export const exportAccountsToCSV = async (filters?: any): Promise<Blob> => {
  try {
    // تحويل الفلاتر إلى query string
    const filteredEntries = Object.entries(filters || {})
      .filter(([_, v]) => v !== '')
      .reduce((acc, [k, v]) => ({ ...acc, [k]: String(v) }), {} as Record<string, string>);
    
    const queryString = new URLSearchParams(filteredEntries).toString();
    const url = `/finance/accounts/export/csv${queryString ? '?' + queryString : ''}`;
    
    const response = await apiService.getBlob(url);
    return response;
  } catch (error) {
    console.error('Error exporting accounts to CSV:', error);
    throw error;
  }
};

// تصدير الحسابات إلى Excel
export const exportAccountsToExcel = async (filters?: any): Promise<Blob> => {
  try {
    // تحويل الفلاتر إلى query string
    const filteredEntries = Object.entries(filters || {})
      .filter(([_, v]) => v !== '')
      .reduce((acc, [k, v]) => ({ ...acc, [k]: String(v) }), {} as Record<string, string>);
    
    const queryString = new URLSearchParams(filteredEntries).toString();
    const url = `/finance/accounts/export/excel${queryString ? '?' + queryString : ''}`;
    
    const response = await apiService.getBlob(url);
    return response;
  } catch (error) {
    console.error('Error exporting accounts to Excel:', error);
    throw error;
  }
};

// إعادة حساب الأرصدة
export const recalculateAccountBalances = async (accountId?: string): Promise<any> => {
  try {
    const url = accountId
      ? `/finance/accounts/recalculate-balances/${accountId}`
      : '/finance/accounts/recalculate-balances';
    const response = await apiService.post(url, {});
    return response;
  } catch (error) {
    console.error('Error recalculating account balances:', error);
    throw error;
  }
};

// استيراد الحسابات من ملف
export const importAccounts = async (file: File): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await apiService.postFormData('/finance/accounts/import', formData);
    return response;
  } catch (error) {
    console.error('Error importing accounts:', error);
    throw error;
  }
};

// تحميل نموذج الاستيراد
export const downloadImportTemplate = async (): Promise<Blob> => {
  try {
    const response = await apiService.getBlob('/finance/accounts/import/template');
    return response;
  } catch (error) {
    console.error('Error downloading import template:', error);
    throw error;
  }
};